import { render, staticRenderFns } from "./Speakabout.vue?vue&type=template&id=5ae5c256"
var script = {}
import style0 from "./Speakabout.vue?vue&type=style&index=0&id=5ae5c256&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports